import React, { Component } from 'react';
import './user-sign.less'
import { setHeader } from '@/util/set-header';
import SignaturePad from "react-signature-pad";
import { uploadImageApi } from "@/api/sany";
import { signAddApi } from "@/api/sany";
import { Toast } from "antd-mobile";
import { withRouter } from 'react-router'
@(withRouter as any)
export default class UserSign extends Component<any, any> {
    img_url = ''
    isUpLoading = false
    UNSAFE_componentWillMount() {
        setHeader({ className: "sign-navbar" })
    }
    componentDidMount() {
        let canvas: any = document.querySelector('canvas')
        var ctx = canvas.getContext("2d");
        //  设置宽高
        canvas.width = document.body.clientWidth
        canvas.height = document.body.clientHeight
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.refs.mySignature = new SignaturePad(canvas, {
            width: document.body.clientWidth,
            backgroundColor: '#fff',
            penColor: 'rgb(66, 133, 244)'
        })
    }
    leftBtn = () => {
        this.props.history.goBack()
        // const transaction_id = this.props.location.query.transaction_id
        // this.props.history.replace({ pathname: `/receipt-detail/${transaction_id}` })
    }
    // 旋转图片src：无论是url地址还是base64数据都可以
    rotateBase64Img(src: any, edg: any, callback: any) {

        var canvas = document.createElement("canvas");
        var ctx: any = canvas.getContext("2d");

        var imgW;//图片宽度
        var imgH;//图片高度
        var size;//canvas初始大小

        if (edg % 90 !== 0) {
            console.error("旋转角度必须是90的倍数!");
            return
        }
        (edg < 0) && (edg = (edg % 360) + 360)
        const quadrant = (edg / 90) % 4; //旋转象限
        const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标

        var image = new Image();
        image.crossOrigin = "anonymous"
        image.src = src;

        image.onload = function () {

            imgW = image.width;
            imgH = image.height;
            size = imgW > imgH ? imgW : imgH;

            canvas.width = size * 2;
            canvas.height = size * 2;
            switch (quadrant) {
                case 0:
                    cutCoor.sx = size;
                    cutCoor.sy = size;
                    cutCoor.ex = size + imgW;
                    cutCoor.ey = size + imgH;
                    break;
                case 1:
                    cutCoor.sx = size - imgH;
                    cutCoor.sy = size;
                    cutCoor.ex = size;
                    cutCoor.ey = size + imgW;
                    break;
                case 2:
                    cutCoor.sx = size - imgW;
                    cutCoor.sy = size - imgH;
                    cutCoor.ex = size;
                    cutCoor.ey = size;
                    break;
                case 3:
                    cutCoor.sx = size;
                    cutCoor.sy = size - imgW;
                    cutCoor.ex = size + imgH;
                    cutCoor.ey = size + imgW;
                    break;
            }
            ctx.translate(size, size);
            ctx.rotate(edg * Math.PI / 180);
            ctx.drawImage(image, 0, 0);

            var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
            if (quadrant % 2 === 0) {
                canvas.width = imgW;
                canvas.height = imgH;
            } else {
                canvas.width = imgH;
                canvas.height = imgW;
            }
            ctx.putImageData(imgData, 0, 0);
            callback(canvas.toDataURL())
        };
    }

    //验证canvas画布是否为空函数
    isCanvasBlank(canvas: any) {
        var blank = document.createElement('canvas');//系统获取一个空canvas对象
        var ctx: any = blank.getContext("2d");
        blank.width = document.body.clientWidth;
        blank.height = document.body.clientHeight;
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // console.log(canvas.toDataURL(), 'xxxxxxx', blank.toDataURL())
        return canvas.toDataURL() === blank.toDataURL();//比较值相等则为空
    }
    // 提交
    rightBtn = () => {
        if (!this.isUpLoading) {
            this.isUpLoading = true
            var canvasElement: any = document.querySelector('canvas')
            if (this.isCanvasBlank(canvasElement)) {
                Toast.info('签名不可为空~', 1.5)
                this.isUpLoading = false
                return
            }
            var MIME_TYPE = "image/png";
            var imgURL = canvasElement.toDataURL(MIME_TYPE);
            this.clearPad()
            var that = this
            this.rotateBase64Img(imgURL, -90, (url: any) => {
                that.uploadImage(url)
            })
        }
    }
    // base64转二进制
    dataURLToBlob(dataURL: any) {
        let parts = dataURL.split(';base64,')
        let contentType = parts[0].split(':')[1]
        let raw = window.atob(parts[1])
        let rawLength = raw.length
        let uInt8Array = new Uint8Array(rawLength)

        for (var i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i)
        }

        return new Blob([uInt8Array], { type: contentType })
    }
    // 上传图片
    async uploadImage(url: any) {
        let blob = this.dataURLToBlob(url)
        let formData = new FormData()
        formData.append('image', blob)
        formData.append('type', 'user_face')
        Toast.loading('上传中', 0)
        const { data } = await uploadImageApi(formData)
        Toast.hide()
        if (data.code === 'SUCCESS') {
            this.img_url = data.data.url
            this.receiptSignSubmit()
        } else {
            this.isUpLoading = false
            Toast.info(data.msg, 2)
        }
    }
    // 单据签名
    receiptSignSubmit = async () => {
        const contractId = this.props.location.state.contractId
        const num = this.props.location.state.num
        const params = { img: this.img_url, contract_id: contractId, num: num }
        Toast.loading('上传中', 0)
        const res: any = await signAddApi({data: params})
        Toast.hide()
        this.isUpLoading = false
        if (res.data.code === 'SUCCESS') {
            this.leftBtn()
        } else {
            Toast.info(res.data.msg, 2)
        }
    }

    clearPad = () => {
        let canvas: any = document.querySelector('canvas')
        var cxt = canvas.getContext("2d");
        cxt.clearRect(0, 0, canvas.width, canvas.height);
        cxt.fillStyle = '#fff';
        cxt.fillRect(0, 0, canvas.width, canvas.height);
    }
    render() {
        return (
            <div className="user-sign">
                <div className="sign-Horizontal">
                    <div className="nav-bar">
                        <span style={{ color: 'orange' }} onClick={this.leftBtn}>取消</span>
                        <span>签名</span>
                        <span style={{ color: 'orange' }} onClick={this.rightBtn}>提交</span>
                    </div>
                    <SignaturePad className="user-sign-pad" ref="mySignature" />
                    <span className="clear-sign" onClick={this.clearPad}>重新签名</span>
                </div>
            </div>
        )
    }
}

